import { Injectable }       from '@angular/core';
import { NgbModal }         from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }                    from '../api/api.service';
import { QuickbooksAccountsModel }       from './models/quickbooks.accounts';
import { QuickbooksDisclaimerComponent } from './quickbooks.disclaimer.component';
import { SessionService }             from '../sessions/session.service';
import { SyncQuickbooksComponent }       from './quickbooks.sync.component';

@Injectable({
  providedIn: 'root'
})
export class QuickbooksService {
  constructor (
    private apiService      : ApiService,
    private modalService    : NgbModal,
    private sessionService  : SessionService,
    private translateService: TranslateService
  ) {}

  authorize () : Promise<any> {
    if (this.sessionService.company().has_xero) {
      return Promise.reject(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACCOUNTING_UNAUTH_FIRST', {
        name1: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.QUICKBOOKS.QUICKBOOKS_ONLINE'),
        name2: 'Xero'
      }));
    }
    else if (this.sessionService.company().has_myob) {
      return Promise.reject(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACCOUNTING_UNAUTH_FIRST', {
        name1: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.QUICKBOOKS.QUICKBOOKS_ONLINE'),
        name2: 'MYOB'
      }));
    } else {
      return this.apiService.get('/quickbooks_online/is_unlinked')
      .then(response => response ? this.launchDisclaimer() : Promise.resolve());
    }
  }

  checkExistingIntegrations () : Promise<any> {
    return this.apiService.get('/company/accounting_ids_exist/qbo');
  }

  clearID () : Promise<any> {
    return this.apiService.post('/company/clear_accounting_contact_ids', {
      accounting_integration: 'qbo',
      confirmation          : 'CLEAR IDS'
    });
  }

  getAccounts () : Promise<QuickbooksAccountsModel> {
    return this.apiService.get('/quickbooks_online/accounts');
  }

  launchDisclaimer () : Promise<any> {
    return this.modalService.open(QuickbooksDisclaimerComponent).result;
  }

  shareAccount ( shareAccountFlag : boolean ) : Promise<any> {
    return this.apiService.get('/company/share_accounting', [ shareAccountFlag ? 't' : 'f' ]);
  }

  sync () : Promise<any> {
    return this.modalService.open(SyncQuickbooksComponent).result;
  }
}